module.exports = __webpack_public_path__ + "static/media/estrela.e7cc7fed.svg";